<div *ngIf="loadingService.isLoading()" class="global-loading-overlay">
  <div class="spinner"></div>
  <br>
  <p>Logging you in, please wait...</p>
</div>

<router-outlet></router-outlet>
